import { createStore } from 'vuex';
import axios from 'axios';
import translations from './modules/translations';

const auth = {
  namespaced: true,

  state: {
    user: null
  },

  getters: {
    isAuthenticated: state => !!state.user,
    getUser: state => state.user,
    isAdmin: state => state.user?.isAdmin || false
  },

  mutations: {
    setUser(state, user) {
      state.user = user;
    },
    clearUser(state) {
      state.user = null;
    }
  },

  actions: {
    async checkAuth({ commit }) {
      try {
        const response = await axios.get('/api/auth/check-auth', {
          withCredentials: true
        });
        if (response.data.isAuthenticated) {
          commit('setUser', response.data.user);
          return response.data;
        } else {
          commit('clearUser');
          return { isAuthenticated: false };
        }
      } catch (error) {
        console.error('Auth check error:', error);
        commit('clearUser');
        return { isAuthenticated: false };
      }
    }
  }
};

const store = createStore({
  modules: {
    auth,
    translations
  }
});

export default store;
